module.exports = __webpack_public_path__ + "img/patrick-tomasso-gMes5dNykus-unsplash.81272a7c.jpg";